export const calcKeys = [
  'insurancePremium',
  'insuranceMonthlyPayment',
  'countyTaxMonthlyPayment',
  'totalEscrowPayment',
  'insuranceAmountCollected',
  'insuranceMonthCollected',
  'taxAmountCollected',
  'taxMonthCollected',
  'insuranceAgentName',
  'insuranceAgentAddress',
  'insuranceCompanyName',
]
